import React, { createContext, useState, useContext, useEffect } from 'react';

const SignupContext = createContext();

export const SignupProvider = ({ children }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [agreedTermIds, setAgreedTermIds] = useState([]);
  const [verified, setVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeSignup = () => {
      const savedTerms = localStorage.getItem('termsAccepted') === 'true';
      const savedIds   = JSON.parse(localStorage.getItem('agreedTermIds') || '[]');
      const savedVerified = localStorage.getItem('verified') === 'true';

      setAgreedTermIds(savedIds);
      setTermsAccepted(savedTerms);
      setVerified(savedVerified);
      setIsLoading(false);
    };

    initializeSignup();
  }, []);

  useEffect(() => {
    localStorage.setItem('termsAccepted', termsAccepted);
    localStorage.setItem('verified', verified);
    localStorage.setItem('agreedTermIds', JSON.stringify(agreedTermIds));
  }, [termsAccepted, agreedTermIds, verified]);

  return (
    <SignupContext.Provider value={{ termsAccepted, setTermsAccepted, verified, setVerified, agreedTermIds, setAgreedTermIds, isLoading }}>
      {children}
    </SignupContext.Provider>
  );
};

export const useSignup = () => {
  const context = useContext(SignupContext);
  if (!context) {
    throw new Error('useSignup must be used within a SignupProvider');
  }
  return context;
};
